import { useEffect } from "react";
import { getContainer } from "../ioc/IOCSetup";
import { useHistory } from "react-router";
import { FullPageLoading } from "./GlifeView";
import { UserService } from "../user/UserService";

const RESET_PASSWORD_LINK = `/?type=recover&modal=user`;

const GlifeResetPassword = () => {
  const history = useHistory();
  const userService: UserService = getContainer().getUserService();

  useEffect(() => {
    const logoutAndRedirect = async () => {
      await userService.logout();
      history.push(RESET_PASSWORD_LINK);
    };

    logoutAndRedirect();
  }, []);

  return <FullPageLoading />;
};

export default GlifeResetPassword;
